import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

/**
 * Full-bleed loading cover for the explorer's content pane.
 *
 * Sits on top of the iframe rather than replacing it, so a map or PDF that
 * takes several seconds to render never shows a blank frame.
 */
const ViewerLoading = ({ label, hint }) => (
  <Box sx={{ position: 'absolute', inset: 0, zIndex: 1, bgcolor: 'background.paper' }}>
    <LinearProgress />
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      {hint && (
        <Typography variant="caption" color="text.disabled">
          {hint}
        </Typography>
      )}
    </Box>
  </Box>
);

export default ViewerLoading;
